import { render, staticRenderFns } from "./EditDistrictTypePage.vue?vue&type=template&id=0beab6ea&"
import script from "./EditDistrictTypePage.vue?vue&type=script&lang=js&"
export * from "./EditDistrictTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports